import type { ParametricFilter } from "@nwt/norce-pwa/dist/runtime/types/api/searchAndFilter/filters";

// A boolean parametric arrives as a group holding one "true" option (see
// booleanParametricFilter in norce-pwa). Its group key has no parametric code
// to look a name up by, so the header takes the name from that option.
export const getBooleanFilterName = (filters: unknown): string | undefined => {
	if (!Array.isArray(filters) || filters.length !== 1) return undefined;

	const [option] = filters as ParametricFilter[];
	return option && isBooleanParametricValueId(option.Id)
		? option.Name
		: undefined;
};
